import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  MatProgressSpinnerModule,
  ProgressSpinnerMode,
} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {
  @Input() loading: boolean | null = false;
  @Input() color = 'primary';
  @Input() bgColor = 'inherit';
  @Input() mode: ProgressSpinnerMode = 'indeterminate';
  @Input() value = 50;
  @Input() fixed = false;
  @Input() overlay = false;
  @Input() overlayLight = false;
}
